import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import { getUserlangKey } from 'ptz-i18n';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  DropdownToggle,
  DropdownItem,
} from 'reactstrap';

import HeaderLink from './HeaderLink';
import HeaderDropdown from './HeaderDropdown';
import HeaderDropdownItem from './HeaderDropdownItem';
import ChangeLang from './ChangeLang';

import './Header.scss';

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      screenWidth: '',
    };

    this.toggle = this.toggle.bind(this);
    this.toggleSmallMenu = this.toggleSmallMenu.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ screenWidth: window.innerWidth });
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  toggleSmallMenu() {
    const { screenWidth } = this.state;
    if (screenWidth < 768) {
      this.toggle();
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  render() {
    const { langKey, langChange, data, title } = this.props;
    const content = langKey === 'fr' ? data.fr : data.en;

    return (
      <Navbar dark expand="md navbar-offshore text-white fixed-top">
        <NavbarBrand
          tag={Link}
          to={`/${langKey}/`}
          onClick={this.state.isOpen ? this.toggleSmallMenu : null}
        >
          <Img
            alt={content.logo.title}
            resolutions={content.logo.resolutions}
          />
        </NavbarBrand>
        <NavbarBrand
          tag={Link}
          to={`/${langKey}/`}
          onClick={this.state.isOpen ? this.toggleSmallMenu : null}
        >
          <div className="title">{title}</div>
        </NavbarBrand>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            {/* Accueil */}
            <HeaderLink
              to={`/${langKey}/`}
              title={content.home}
              onClick={this.toggleSmallMenu}
            />
            {/* Nos Services */}
            <HeaderLink
              to={`/${langKey}/services`}
              title={content.nosServices}
              onClick={this.toggleSmallMenu}
            />
            {/* Nos Marques */}
            <HeaderDropdown title={content.nosMarques}>
              <HeaderDropdownItem
                title="Caterpillar"
                to={`/${langKey}/caterpillar`}
                onClick={this.toggleSmallMenu}
              />
              <HeaderDropdownItem
                title="Mercury / Mercruiser"
                to={`/${langKey}/mercury-mercruiser`}
                onClick={this.toggleSmallMenu}
              />
              <HeaderDropdownItem
                title="Yanmar"
                to={`/${langKey}/yanmar`}
                onClick={this.toggleSmallMenu}
              />
              <HeaderDropdownItem
                title="Köhler"
                to={`/${langKey}/kohler`}
                onClick={this.toggleSmallMenu}
              />
            </HeaderDropdown>
            {/* A PROPOS */}
            <HeaderLink
              to={`/${langKey}/about`}
              title={content.aPropos}
              onClick={this.toggleSmallMenu}
            />
            {/* Contact */}
            <HeaderLink
              to={`/${langKey}/contact`}
              title="Contact"
              onClick={this.toggleSmallMenu}
            />
            {/* Blog */}
            <HeaderLink
              to={`/${langKey}/blog`}
              title="Blog"
              onClick={this.toggleSmallMenu}
            />
            {/* changeLang */}
            <ChangeLang
              langChange={this.props.langChange}
              toggleSmallMenu={this.toggleSmallMenu}
              locale={langKey}
            />
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}

Header.propTypes = {
  langKey: PropTypes.string,
  langChange: PropTypes.func,
  data: PropTypes.object,
  title: PropTypes.string,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js